// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__EJDk5","icon":"style_icon__bVV29","content-box":"style_content-box__zzxMb"};